module.exports = __webpack_public_path__ + "static/media/PaternityLeave.09552db3.svg";